<ng-container *transloco="let t; read: 'common'">
  <div class="layout-footer" role="contentinfo">
      <div class="footer-logo-container">
          <span class="app-name">{{ t('assessment_runner_administration') }}</span>
      </div>
      <span class="copyright">&#169; cemedia 2020 - {{ date | amLocal | amDateFormat: 'YYYY' }}</span>
  </div>
</ng-container>
